import React from 'react';
import StudentAssignments from './StudentAssignments';

interface StudentDashboardProps {
  onClose?: () => void;
  onStartGame: (dictionary: any, assignmentId?: number, gameId?: number, pairCount?: number) => void;
}

const StudentDashboard: React.FC<StudentDashboardProps> = ({ onClose, onStartGame }) => {
  return (
    <div className="student-dashboard">
      <div className="student-header">
        <h2>📚 Student Dashboard</h2>
        {onClose && (
          <button onClick={onClose} className="close-button">
            ✕ Close
          </button>
        )}
      </div>

      <StudentAssignments onClose={onClose || (() => {})} onStartGame={onStartGame} />
    </div>
  );
};

export default StudentDashboard;
